export enum MediaContext {
  SOURCE = <any>'SOURCE',
  TRANS = <any> 'TRANS',
}
